import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import MobileMenu from '../MobileMenu/MobileMenu'
import { totalPrice } from "../../utils";
import { connect } from "react-redux";
import { removeFromCart } from "../../store/actions/action";



import User from '../../images/user.svg'
import Heart from '../../images/heart.svg'
import Card from '../../images/shopping-cart.svg'


/* Homefullviewimage */
import Home1 from '../../images/home/modern-architecture.jpg'
import Home2 from '../../images/home/classic-architecture.jpg'
import Home3 from '../../images/home/modern-architecture-s2.jpg'
import Home4 from '../../images/home/classic-architecture-dark.jpg'
import Home5 from '../../images/home/classic-interior-design.jpg'
import Home6 from '../../images/home/classic-interior-design-s2.jpg'
import Home7 from '../../images/home/classic-interior-design-dark.jpg'
import Home8 from '../../images/home/renovation.jpg'
import Home9 from '../../images/home/modern-woocommerce.jpg'
import Home10 from '../../images/home/minimal-woocommerce-s2.jpg'
import Home11 from '../../images/home/urban-planning.jpg'
import Home12 from '../../images/home/costruction.jpg'
import Home13 from '../../images/home/costruction-s2.jpg'
import Home14 from '../../images/home/construction-profile.jpg'
import Home15 from '../../images/home/frelancer-architect.jpg'


const ClickHandler = () => {
    window.scrollTo(10, 0);
}
const HeaderS2 = (props) => {

   const [cartActive, setcartState] = useState(false);
    const { carts, wishs } = props;
    const [query, setQuery] = useState("");
    
    const handleSubmit = (event) => {
        event.preventDefault();
    };

    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);

    const toggleMenu = (event) => {
        event.stopPropagation();
        setIsOpen((prev) => !prev);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);








    

    return (
        <header id="header">
            <div className={"" + props.hclass} >
                <nav className="navigation navbar navbar-expand-lg navbar-light">
                    <div className="container-fluid">
                        <div className="row align-items-center g-0">
                            <div className={"" + props.col1}>
                                <div className="mobail-menu">
                                    <MobileMenu />
                                </div>
                            </div>
                            <div className={"" + props.col3}>
                               <div id="navbar" className="collapse navbar-collapse navigation-holder">
                                    <button className="menu-close"><i className="ti-close"></i></button>
                                    <ul className="nav navbar-nav mb-2 mb-lg-0">
                                        <li className="menu-item-has-children image-style-item">
                                            <Link onClick={ClickHandler} to="#">Home</Link>
                                            <ul className="sub-menu image-style">
                                                <li>
                                                    <Link onClick={ClickHandler} to="/home">
                                                        <small className="inner">
                                                            <img src={Home1}
                                                                alt="" />
                                                        </small>
                                                        <span>Modern Architecture</span>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link onClick={ClickHandler} to="/bliize-classic-architecture">
                                                        <small className="inner">
                                                            <img src={Home2}
                                                                alt="" />
                                                        </small>
                                                        <span>Classic Architecture</span>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link onClick={ClickHandler} to="/bliize-modern-architecture-s2">
                                                        <small className="inner">
                                                            <img src={Home3}
                                                                alt="" />
                                                        </small>
                                                        <span>Modern Architecture 02</span>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link onClick={ClickHandler} to="/bliize-classic-architecture-dark">
                                                        <small className="inner">
                                                            <img src={Home4}
                                                                alt="" />
                                                        </small>
                                                        <span>Classic Architecture Dark</span>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link onClick={ClickHandler} to="/bliize-classic-interior-design">
                                                        <small className="inner">
                                                            <img src={Home5}
                                                                alt="" />
                                                        </small>
                                                        <span>Classic Interior Design</span>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link onClick={ClickHandler} to="/bliize-classic-interior-design-s2">
                                                        <small className="inner">
                                                            <img src={Home6}
                                                                alt="" />
                                                        </small>
                                                        <span>Classic Interior Design 02</span>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link onClick={ClickHandler} to="/bliize-classic-interior-design-dark">
                                                        <small className="inner">
                                                            <img src={Home7}
                                                                alt="" />
                                                        </small>
                                                        <span>Classic Interior Design Dark</span>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link onClick={ClickHandler} to="/bliize-renovation">
                                                        <small className="inner">
                                                            <img src={Home8} alt="" />
                                                        </small>
                                                        <span>Renovation</span>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link onClick={ClickHandler} to="/bliize-modern-woocommerce">
                                                        <small className="inner">
                                                            <img src={Home9} alt="" />
                                                        </small>
                                                        <span>Modern Woocommerce</span>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link onClick={ClickHandler} to="/bliize-minimal-woocommerce">
                                                        <small className="inner">
                                                            <img src={Home10}
                                                                alt="" />
                                                        </small>
                                                        <span>Minimal Woocommerce</span>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link onClick={ClickHandler} to="/bliize-urban-planning">
                                                        <small className="inner">
                                                            <img src={Home11} alt="" />
                                                        </small>
                                                        <span>Urban Planning</span>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link onClick={ClickHandler} to="/bliize-costruction">
                                                        <small className="inner">
                                                            <img src={Home12} alt="" />
                                                        </small>
                                                        <span>Costruction</span>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link onClick={ClickHandler} to="/bliize-costruction-s2">
                                                        <small className="inner">
                                                            <img src={Home13} alt="" />
                                                        </small>
                                                        <span>Costruction 02</span>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link onClick={ClickHandler} to="/bliize-costruction-profile">
                                                        <small className="inner">
                                                            <img src={Home14}
                                                                alt="" />
                                                        </small>
                                                        <span>Costruction Profile</span>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link onClick={ClickHandler} to="/bliize-frelancer-architect">
                                                        <small className="inner">
                                                            <img src={Home15}
                                                                alt="" />
                                                        </small>
                                                        <span>Frelancer Architect</span>
                                                    </Link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="#">Pages</Link>
                                            <ul className="sub-menu">
                                                <li><Link onClick={ClickHandler} to="/about">About Us</Link></li>
                                                <li className="menu-item-has-children">
                                                    <Link onClick={ClickHandler} to="#">Services</Link>
                                                    <ul className="sub-menu">
                                                        <li><Link onClick={ClickHandler} to="/services">Services</Link></li>
                                                        <li><Link onClick={ClickHandler} to="/service-single/Custom-Solutions">Service single</Link></li>
                                                    </ul>
                                                </li>
                                                <li className="menu-item-has-children">
                                                    <Link onClick={ClickHandler} to="#">Team</Link>
                                                    <ul className="sub-menu">
                                                        <li><Link onClick={ClickHandler} to="/team">Team</Link></li>
                                                        <li><Link onClick={ClickHandler} to="/team-single/Robert-Fox">Team single</Link></li>
                                                    </ul>
                                                </li>
                                                <li><Link onClick={ClickHandler} to="/pricing">Pricing</Link></li>
                                                <li><Link onClick={ClickHandler} to="/login">Login</Link></li>
                                                <li><Link onClick={ClickHandler} to="/contact">Contact Us</Link></li>
                                                <li><Link onClick={ClickHandler} to="/privace">Privace</Link></li>
                                                <li><Link onClick={ClickHandler} to="/terms">Terms</Link></li>
                                                <li><Link onClick={ClickHandler} to="/404">404 Error</Link></li>
                                            </ul>
                                        </li>
                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="#">Projects</Link>
                                            <ul className="sub-menu">
                                                <li><Link onClick={ClickHandler} to="/projects">Projects</Link></li>
                                                <li><Link onClick={ClickHandler} to="/project-single/Modern-House-In-UK">Projects Single</Link></li>
                                            </ul>
                                        </li>
                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="#">Shop</Link>
                                            <ul className="sub-menu">
                                                <li><Link onClick={ClickHandler} to="/shop">Shop</Link></li>
                                                <li><Link onClick={ClickHandler} to="/shop-single/Fresh-key-Lime">Shop Single</Link></li>
                                                <li><Link onClick={ClickHandler} to="/cart">Cart</Link></li>
                                                <li><Link onClick={ClickHandler} to="/checkout">Checkout</Link></li>
                                                <li><Link onClick={ClickHandler} to="/wishlist">Wishlist</Link></li>
                                            </ul>
                                        </li>
                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="#">Blog</Link>
                                            <ul className="sub-menu">
                                                <li><Link onClick={ClickHandler} to="/blog">Blog right sidebar</Link></li>
                                                <li><Link onClick={ClickHandler} to="/blog-left-sidebar">Blog left sidebar</Link></li>
                                                <li><Link onClick={ClickHandler} to="/blog-fullwidth">Blog fullwidth</Link></li>
                                                <li className="menu-item-has-children">
                                                    <Link onClick={ClickHandler} to="#">Blog details</Link>
                                                    <ul className="sub-menu">
                                                        <li><Link onClick={ClickHandler} to="/blog-single/How-To-Teach-Kids-Ramadan-Isn’t-About-Food1">Blog details right sidebar</Link>
                                                        </li>
                                                        <li><Link onClick={ClickHandler} to="/blog-single-left-sidebar/How-To-Teach-Kids-Ramadan-Isn’t-About-Food1">Blog details left
                                                            sidebar</Link></li>
                                                        <li><Link onClick={ClickHandler} to="/blog-single-fullwidth/How-To-Teach-Kids-Ramadan-Isn’t-About-Food1">Blog details
                                                            fullwidth</Link></li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className={"" + props.col2}>
                                <div className="navbar-header">
                                    <Link onClick={ClickHandler} className="navbar-brand" to="/home"><img src={props.Logo}
                                        alt="" /></Link>
                                </div>
                            </div>
                            <div className={"" + props.col4}>
                                <div className="header-right">
                                    <div className="header-search-form-s2">
                                        <form onSubmit={handleSubmit}>
                                            <div>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Search here..."
                                                    value={query}
                                                    onChange={(e) => setQuery(e.target.value)}
                                                />
                                                <button type="submit">
                                                    <i className="fi flaticon-loupe"></i>
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                    <div className="header-user-wrapper" ref={menuRef}>
                                        <div className="cart-user-contact">
                                            <button className="user-toggle-btn" onClick={toggleMenu}>
                                                <img src={User} alt="User" />
                                            </button>
                                            {isOpen && (
                                                <div className="header-user-form header-user-content-toggle">
                                                    <ul>
                                                        <li><Link onClick={ClickHandler} to="/login">Login</Link></li>
                                                        <li><Link onClick={ClickHandler} to="/register">Register</Link></li>
                                                        <li><Link onClick={ClickHandler} to="/contact">Contact Us</Link></li>
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="heart-cart">
                                        <Link onClick={ClickHandler} to="/wishlist"><img src={Heart} alt="" />
                                        <span className="cart-count">{wishs.length}</span>
                                        </Link>
                                    </div>
                                    <div className="mini-cart">
                                        <button className="cart-toggle-btn" onClick={() => setcartState(!cartActive)}>
                                            {" "}
                                            <img src={Card}
                                                alt="" />{" "}
                                            <span className="cart-count">{carts.length}</span>
                                        </button>
                                        <div className={`mini-cart-content ${cartActive ? "mini-cart-content-toggle" : ""}`}>
                                            <button className="mini-cart-close" onClick={() => setcartState(!cartActive)}><i className="ti-close"></i></button>
                                            <div className="mini-cart-items">
                                                {carts &&
                                                    carts.length > 0 &&
                                                    carts.map((catItem, crt) => (
                                                        <div className="mini-cart-item clearfix" key={crt}>
                                                            <div className="mini-cart-item-image">
                                                                <span>
                                                                    <img src={catItem.proImg} alt="icon" />
                                                                </span>
                                                            </div>
                                                            <div className="mini-cart-item-des">
                                                                <p>{catItem.title} </p>
                                                                <span className="mini-cart-item-price">
                                                                    ${catItem.price} x {" "} {catItem.qty}
                                                                </span>
                                                                <span className="mini-cart-item-quantity">
                                                                    <button
                                                                        onClick={() =>
                                                                            props.removeFromCart(catItem.id)
                                                                        }
                                                                        className="btn btn-sm btn-danger"
                                                                    >
                                                                        <i className="ti-close"></i>
                                                                    </button>{" "}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    ))}
                                            </div>
                                            <div className="mini-cart-action clearfix">
                                                <span className="mini-checkout-price">Subtotal: <span> ${totalPrice(carts)}</span></span>
                                                <div className="mini-btn">
                                                    <Link to="/checkout" className="view-cart-btn s1">Checkout</Link>
                                                    <Link to="/cart" className="view-cart-btn">View Cart</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    )
}
const mapStateToProps = (state) => {
    return {
        carts: state.cartList.cart,
        wishs: state.wishList.w_list,
    };
};

export default connect(mapStateToProps, { removeFromCart })(HeaderS2);


